export default __webpack_public_path__ + "static/media/Foro_Innovación.0663caf6.svg";